export default "__VITE_PUBLIC_ASSET__4e56d25e__"